
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class IpWithFrequentCampaignEvents extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.ipWithFrequentCampaignEvents) {
      this.$set(this.conditions, 'ipWithFrequentCampaignEvents', {
        predicate: 'EQUALS',
        values: 'IP_NOT_WITH_FREQUENT_CAMPAIGN_EVENTS'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.ipWithFrequentCampaignEvents, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.ipWithFrequentCampaignEvents, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.ipWithFrequentCampaignEvents.values;
  }

}
